export const TRIAL_EXTENSION_MODAL_CLASS =
  'mb-auto flex h-fit flex-col gap-0 overflow-hidden border-0 p-0 sm:w-11/12 sm:max-w-[647px]';

/** Tier modal (Pro/Clinician) – Figma: Width Fill 470px, Height Hug */
export const TRIAL_EXTENSION_TIER_MODAL_CLASS =
  'mb-auto flex w-full max-w-[470px] flex-col gap-0 overflow-hidden border-0 p-0 sm:w-full';

export const TRIAL_EXTENSION_OVERLAY_CLASS = 'backdrop-blur-[3px]';
